import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { func } from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { useDebounce } from "use-debounce";
import {
  TextInputLabel,
  RequiredFieldDivError,
  TextInputLabelRequired,
} from "./ParentCompany.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";

const ParentCompany = (props) => {
  const {
    t,
    formData,
    setFormData,
    isEditMode,
    objectType,
    queryParamType,
    isEditable,
    setAllCompanyList,
    objectId,
    leadId,
    isLeadCompanyUpdated,
    setLeadCompanyUpdated,
    countryId,
    resetParentCompany,
  } = props;

  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isCompanySuggestionsLoading, setCompanySuggestionsLoading] =
    useState(false);
  useEffect(() => {
    setFormData({
      ...formData,
      company: {
        value: selectedCompany,
        error: "",
        required: true,
      },
    });
  }, [selectedCompany]);

  const [query, setQuery] = useState();
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    if (isEditMode) {
      let entityGroupList = [];
      if (formData?.company?.value?.id) {
        entityGroupList.push({
          name: formData?.company?.value?.name,
          id: formData?.company?.value?.id,
        });
      }
      if (selectedCompany === null) setSelectedCompany([]);
      if (selectedCompany?.length === 0) setSelectedCompany(entityGroupList[0]);
    } else if (isLeadCompanyUpdated) {
      let entityGroupList = [];
      if (formData?.company?.value?.id) {
        entityGroupList.push({
          name: formData?.company?.value?.name,
          id: formData?.company?.value?.id,
        });
        setLeadCompanyUpdated(false);
      }
      setSelectedCompany(entityGroupList[0]);
    } else if (
      !isEditMode &&
      formData?.company?.value?.id &&
      queryParamType === null
    ) {
      const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]&objectId=${formData?.company?.value?.id}`;
      getEntityData(url, "selectedDefault");
    } else if (!isEditMode && queryParamType !== null) {
      const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]&objectId=${queryParamType}`;
      getEntityData(url, "selectedDefault");
    } else if (!isEditMode && !leadId) {
      setSelectedCompany([]);
      const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]`;
      getEntityData(url, "selectedDefault");
    } else if (leadId && objectId) {
      setSelectedCompany([]);
      const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]&objectId=${objectId}`;
      getEntityData(url, "selectedDefault");
    }
  }, [objectType, objectId, isLeadCompanyUpdated, countryId]);

  useEffect(() => {
    if (resetParentCompany) {
      setSelectedCompany([]);
      if (isEditMode) {
        const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]`;
        getEntityData(url, "selectedDefault");
      }
    }
  }, [resetParentCompany]);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    searchEntity();
  }, [debounceQuery]);

  const searchEntity = () => {
    const search = query;
    if (search) {
      let url = `/general/search?search=${search}&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]`;
      getEntityData(url, "all");
    }
  };
  const entityDataCache = useRef({});
  const applyEntityData = (companies, type) => {
    let entityGroupList = [];
    companies.map((key) => {
      entityGroupList.push({
        name: key.registrationNumber
          ? key.id + " - " + key.name + " [" + key.registrationNumber + "]"
          : key.id + " - " + key.name,
        id: key.id,
      });
    });
    setCompanyList(entityGroupList);
    setCompanySuggestionsLoading(false);
    if (setAllCompanyList !== null) {
      setAllCompanyList(companies);
    }
    if (type === "selectedDefault" && companies.length === 1) {
      setSelectedCompany(entityGroupList[0]);
    }
  };

  const getEntityData = (url, type) => {
    setCompanySuggestionsLoading(true);
    if (entityDataCache.current[url]) {
      applyEntityData(entityDataCache.current[url], type);
      return;
    }
    axios
      .get(url)
      .then((response) => {
        if (response?.data?.companies) {
          entityDataCache.current[url] = response.data.companies;
          applyEntityData(response.data.companies, type);
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setCompanyList([]);
        setCompanySuggestionsLoading(false);
      });
  };

  return (
    <>
      {objectType === "supplier" && (
        <TextInputLabelRequired error={formData.company.error}>
          {" "}
          {t("COMPANY_PARENT")}
          {isCompanySuggestionsLoading && (
            <ClipLoader size={15} background="#15aee5 !important" />
          )}
        </TextInputLabelRequired>
      )}
      {objectType !== "supplier" && (
        <TextInputLabel error={formData.company.error}>
          {" "}
          {t("COMPANY_PARENT")}
          {isCompanySuggestionsLoading && (
            <ClipLoader size={15} background="#15aee5 !important" />
          )}
        </TextInputLabel>
      )}
      <Autocomplete
        id="tags-outlined"
        disabled={!isEditable}
        options={companyList}
        getOptionLabel={(option) => option.name || " "}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              formData.company.error !== ""
                ? autoSearchInputStylesError
                : autoSearchInputStyles
            }
          />
        )}
        value={selectedCompany}
        onKeyUp={handleChange}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      {formData.company.error !== "" && (
        <RequiredFieldDivError>{formData.company.error}</RequiredFieldDivError>
      )}
    </>
  );
};

ParentCompany.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  objectType: PropTypes.string.isRequired,
  queryParamType: PropTypes.number,
  isEditable: PropTypes.bool,
  setAllCompanyList: PropTypes.func,
  leadId: PropTypes.number,
  resetParentCompany: PropTypes.bool,
};

ParentCompany.defaultProps = {
  isEditMode: false,
  leadId: false,
  queryParamType: null,
  isEditable: true,
  setAllCompanyList: null,
  resetParentCompany: false,
};
export default withTranslation()(ParentCompany);
